import React from "react";
import { Box, Skeleton, useTheme, useMediaQuery } from "@mui/material";

const HomePageSkeleton = () => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
      }}
    >
      {/* Left side - LiveRaces skeleton */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          p: isMediumScreen ? 2.5 : "15px",
          pt: isMediumScreen ? "15px" : "38px",
          pl: isMediumScreen ? "auto" : "38px",
          height: "auto",
          mb: 2,
        }}
      >
        <Box mt={2}>
          {/* Section Title */}

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 3,
              mt: 3,
            }}
          >
            {[1].map((item) => (
              <Box
                key={item}
                sx={{
                  width: {
                    xs: "100%",
                    // md: "49%",
                    // lg: "48%",
                    // xl: "32%",
                  },
                  height: isMediumScreen ? 180 : 420,
                }}
              >
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height="100%"
                  sx={{
                    borderRadius: "12px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
        <Box mt={4}>
          {/* Section Title */}
          <Box display={"flex"} justifyContent={"space-between"}>
            <Skeleton
              variant="text"
              width={150}
              height={40}
              sx={{ mb: 3, backgroundColor: "rgba(255, 255, 255, 0.1)" }}
            />
            <Skeleton
              variant="text"
              width={150}
              height={40}
              sx={{ mb: 3, backgroundColor: "rgba(255, 255, 255, 0.1)" }}
            />
          </Box>
          {/* Race Cards Grid */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 3,
              mt: 3,
            }}
          >
            {[1, 2, 3].map((item) => (
              <Box
                key={item}
                sx={{
                  width: {
                    xs: "47%",
                    md: "49%",
                    lg: "48%",
                    xl: "32%",
                  },
                  height: isMediumScreen ? 130 : 170,
                }}
              >
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height="100%"
                  sx={{
                    borderRadius: "12px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      {/* Right side - fixed content */}
      {!isMediumScreen && (
        <Box
          sx={{
            width: { lg: 370, sm: 300 },
            p: 3,
            height: "auto",
            overflowY: "auto",
          }}
        >
          {/* UserProfile Skeleton */}
          <Box
            sx={{
              bgcolor: "rgba(255, 255, 255, 0.05)",
              mt: 3,
              p: 3,
              borderRadius: "16px",
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}
            >
              <Skeleton
                variant="circular"
                width={57}
                height={57}
                sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
              />
              <Box>
                <Skeleton
                  variant="text"
                  width={120}
                  sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                />
                <Skeleton
                  variant="text"
                  width={80}
                  sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                />
              </Box>
            </Box>

            <Skeleton
              variant="rectangular"
              height={50}
              sx={{
                my: 2,
                borderRadius: "12px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              }}
            />

            <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
              <Skeleton
                variant="rectangular"
                width="50%"
                height={40}
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                }}
              />
              <Skeleton
                variant="rectangular"
                width="50%"
                height={40}
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                }}
              />
            </Box>

            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: "8px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              }}
            />
          </Box>

          {/* Chat Section Skeleton */}
          <Box mt={4}>
            <Box
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.05)",
                borderRadius: "12px",
                pb: 3,
              }}
            >
              {/* Chat Header */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  background: "rgba(255, 255, 255, 0.07)",
                  borderTopRightRadius: "12px",
                  borderTopLeftRadius: "12px",
                  p: 1.5,
                  pl: 2.5,
                  pr: 2.5,
                  mb: 2,
                }}
              >
                <Box display="flex">
                  <Skeleton
                    variant="circular"
                    width={40}
                    height={40}
                    sx={{
                      mr: 1.5,
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                    }}
                  />
                  <Box>
                    <Skeleton
                      variant="text"
                      width={80}
                      sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                    />
                    <Skeleton
                      variant="text"
                      width={100}
                      sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                    />
                  </Box>
                </Box>
                <Skeleton
                  variant="circular"
                  width={40}
                  height={40}
                  sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                />
              </Box>

              {/* Chat Message */}
              <Box mx={2.5}>
                <Skeleton
                  variant="rectangular"
                  width={220}
                  height={80}
                  sx={{
                    borderRadius: "12px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    mb: 3,
                  }}
                />
              </Box>

              {/* Chat Input */}
              <Box mx={2.5}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={40}
                  sx={{
                    borderRadius: "4px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                  }}
                />
              </Box>
            </Box>
          </Box>

          {/* Match Finder Button Skeleton */}
          <Box display="flex" justifyContent="left" mt={4}>
            <Skeleton
              variant="rectangular"
              width={400}
              height={120}
              sx={{
                borderRadius: "12px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default HomePageSkeleton;
